import React from 'react';
import { useTranslation } from 'react-i18next';

import { ListProps } from 'component/Layout/Autocomplete/types';

import classNames from 'classnames';

import { stripTags } from 'utility/Format/String';

import { Airport } from 'types/legacy/LastSearch';

import { getAirportLabelList } from '../../__helper/airport';
import { convertUrlParamToValue } from '../../__helper/convert';
import styles from '../Airport.module.scss';

const LastSearch = ({ entries, onClick }: ListProps<Airport>) => {
    const { t } = useTranslation();
    return (
        <>
            <div className={styles.Header}>{t('TRANS-last-searches')}</div>
            <div className={styles.ResultList}>
                {entries?.map((entry) => {
                    const label = getAirportLabelList(
                        convertUrlParamToValue(entry.id),
                        t,
                        true
                    );
                    if (!label) return null;
                    return (
                        <div className={styles.ListItem} key={entry.id}>
                            <div
                                className={classNames(
                                    styles.ListItemContent,
                                    styles.LastSearch
                                )}
                                onClick={() => {
                                    onClick?.(entry);
                                }}
                                dangerouslySetInnerHTML={{ __html: label }}
                                title={stripTags(label)}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default LastSearch;
